import {
  Box3,
  Group,
  MathUtils,
  PerspectiveCamera,
  Vector3,
} from 'three';
import { cloneGltf } from '../engine/loaders.js';

const defaultPos = new Vector3(0.48, -0.42, -1.05);
const adsPos = new Vector3(0.08, -0.24, -0.82);
const recoil = new Vector3();
const recoilVel = new Vector3();
const box = new Box3();
const size = new Vector3();
const VIEWMODEL_ENABLED = false;

let viewmodel = null;

export function initViewmodel(renderer, scene, camera) {
  const viewCamera = new PerspectiveCamera(60, camera.aspect, 0.01, 10);
  const root = new Group();
  root.name = 'weapon-viewmodel';
  root.position.copy(defaultPos);
  root.visible = VIEWMODEL_ENABLED;
  camera.add(root);
  if (!camera.parent) scene.add(camera);

  viewmodel = {
    renderer,
    scene,
    camera,
    viewCamera,
    root,
    weapon: null,
    ads: false,
    adsT: 0,
    sway: 0,
    baseFov: camera.fov,
  };
  return viewmodel;
}

export function setViewmodelWeapon(gltfScene, weaponDef = {}) {
  if (!viewmodel || !gltfScene) return null;
  if (!VIEWMODEL_ENABLED) return null;
  if (viewmodel.weapon) viewmodel.root.remove(viewmodel.weapon);

  const mesh = cloneGltf(gltfScene);
  normalizeWeapon(mesh, weaponDef);
  viewmodel.weapon = mesh;
  viewmodel.root.add(mesh);
  return mesh;
}

export function applyRecoil(amount = 0.1) {
  recoilVel.z += amount * 1.8;
  recoilVel.y += amount * 0.55;
  recoilVel.x += amount * 0.18;
}

export function setADS(active) {
  if (viewmodel) viewmodel.ads = !!active;
}

export function updateViewmodel(dt, player = null) {
  if (!viewmodel) return;
  if (!VIEWMODEL_ENABLED) {
    viewmodel.camera.fov = viewmodel.baseFov;
    viewmodel.camera.updateProjectionMatrix();
    return;
  }
  viewmodel.adsT = MathUtils.damp(viewmodel.adsT, viewmodel.ads ? 1 : 0, 14, dt);
  viewmodel.camera.fov = MathUtils.lerp(viewmodel.baseFov, 45, viewmodel.adsT);
  viewmodel.camera.updateProjectionMatrix();

  recoilVel.multiplyScalar(Math.exp(-dt * 13));
  recoil.addScaledVector(recoilVel, dt);
  recoil.multiplyScalar(Math.exp(-dt * 9));

  const moving = player?.vel?.lengthSq?.() > 0.05;
  viewmodel.sway += dt * (moving ? 9 : 3);
  viewmodel.root.position.lerpVectors(defaultPos, adsPos, viewmodel.adsT);
  viewmodel.root.position.x += Math.sin(viewmodel.sway) * (viewmodel.ads ? 0.01 : 0.035) + recoil.x;
  viewmodel.root.position.y += Math.cos(viewmodel.sway * 1.6) * (viewmodel.ads ? 0.006 : 0.022) + recoil.y;
  viewmodel.root.position.z += recoil.z;
  viewmodel.root.rotation.x = -recoil.y * 0.35;
  viewmodel.root.rotation.y = -recoil.x * 0.55;
}

function normalizeWeapon(mesh, weaponDef) {
  box.setFromObject(mesh);
  box.getSize(size);
  const longest = Math.max(size.x, size.y, size.z, 0.001);
  const target = weaponDef.length || 1.1;
  mesh.scale.setScalar(target / longest);
  box.setFromObject(mesh);
  const center = box.getCenter(new Vector3());
  mesh.position.sub(center);
  mesh.position.set(0, -0.02, -0.18);
  mesh.rotation.set(0, Math.PI, 0);
  mesh.traverse((child) => {
    if (child.isMesh) {
      child.castShadow = true;
      child.receiveShadow = true;
    }
  });
}
